
import React from 'react';
import { Provider } from 'mobx-react'
import OverlayStore from "./src/modules/stores/overlayStore";

// eslint-disable-next-line react/display-name,react/prop-types
const wrapWithProvider = ({ element }) => <Provider store={OverlayStore}>{element}</Provider>;

export default wrapWithProvider;
